<template>
  <div>
    <bread-crumb-cas :routeList="breadArray" labelType="common"></bread-crumb-cas>
    <top-bar :isShowSelect="isShowSelect" placeholder="请选择所属业务" :data="data" :clickAddButton="clickAddButton"></top-bar>
    <div class="search-bar">
      <div class="input-group">
        <el-input style="width: 32%;margin-left: 20px;" v-model="searchParam" placeholder="请输入标签名称"
          clearable></el-input>
        <div class="button-group">
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </div>
      </div>
    </div>
    <circle-table :tableData="tableData" @handleClick="handleClick"></circle-table>
    <pagination @sizePageChange="paginationChangeProduct" :paginationDatas="paginationDataProduct">
    </pagination>
    <el-drawer :visible.sync="dialogShowLabel" direction="rtl" size="40%" :destroy-on-close="true" :title="title"
      :isShowBtn="isShowBtn" :btnText="btnText" @clickHandler="addClickHandler" @one="handleDialogLabel(false)"
      @two="handleDialogSubmitLabel" @close="handleCancelActivateLabel">
      <div class="base-dialog">
        <el-form :rules="rules" :model="formList" label-width="100px" ref="formList">
          <el-form-item label="标签名称" prop="labelName">
            <el-input v-model="formList.labelName" class="base-dialog-input" autocomplete="off" type="text"
              placeholder="请输入" maxlength="10" show-word-limit required></el-input>
          </el-form-item>
          <el-form-item label="标签图片" prop="labelIcon">
            <upload-img-universal @change-title-pic="changeTitlePic" :data="formList.labelIcon" :nocrop="true" />
          </el-form-item>

          <el-form-item label="标签色值" prop="labelStyle">
            <el-color-picker v-model="formList.labelStyle" required />
          </el-form-item>
          <el-form-item label="文字色值" prop="textStyle">
            <el-color-picker v-model="formList.textStyle" required />
          </el-form-item>
          <el-form-item label="标签描述" prop="labelDesc">
            <el-input v-model="formList.labelDesc" class="base-dialog-input" autocomplete="off" type="textarea"
              placeholder="请输入" maxlength="100" :rows="5" show-word-limit required></el-input>
          </el-form-item>
          <el-form-item label="是否自动设为展示标签" prop="isShowDefault">
            <el-radio-group v-model="formList.isShowDefault">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div class="drawer-footer">
        <el-button @click="handleCancelActivateLabel">取消</el-button>
        <el-button type="primary" @click="() => { handleActivateLabel(title) }">
          确定</el-button>
      </div>
    </el-drawer>
    <modal :isShow.sync="moveDialog" title="移动" :isShowBtn="isShowBtn" :btnText="mergeMoveBtnText"
      @clickHandler="moveClickHandler" width="800px">
      <ContentLabelCascader :labelType="1" :selectedId="tableVal.id"
        :functionIds="{ getArticleLabel: 'health_cmp_biz_pageAuditLabels', operateApi: 'health_cmp_moveContentLabel' }"
        ref="moveSelectedRef" />
    </modal>
    <modal :isShow.sync="mergeDialog" title="合并" :isShowBtn="isShowBtn" :btnText="mergeMoveBtnText"
      @clickHandler="mergeClickHandler">
      <ContentLabelCascader :labelType="1" :selectedId="tableVal.id"
        :functionIds="{ getArticleLabel: 'health_cmp_biz_pageAuditLabels', operateApi: 'health_cmp_mergeContentLabel' }"
        ref="moveSelectedRef" />
    </modal>
    <modal :isShow.sync="deleteDialog" title="删除" :isShowBtn="isShowBtn" :btnText="btnText"
      @clickHandler="deleteClickHandler">
      <div class="dialogVal">确认删除</div>
    </modal>
    <modal :isShow.sync="attributeShow" title="属性" :isShowBtn="isShowBtn" :btnText="btnText"
      @clickHandler="btnTextClickHandler">
      <div class="dialogVal">
        <el-checkbox-group v-model="checkedCities" @change="changeCheck">
          <el-checkbox v-for="item in checkList" :key="item.id" :label="item.id">{{ item.name }}</el-checkbox>
        </el-checkbox-group>
      </div>
    </modal>
  </div>
</template>

<script>
import circleTable from "./circleTable.vue"
import pagination from '../../../../components/pagination'
import topBar from "../../../../components/topBar"
import baseTable from "@/components/baseTable"
import ContentLabelCascader from '@/components/select/ContentLabelCascader';
import breadCrumbCas from "../../../../components/breadCrumb.vue"
import modal from "../../../../components/modal"
import uploadImgUniversal from "@/components/upload/uploadImgUniversal";
import {
  saveOrUpdateLabelGroup,
  getTagAttributes,
  jdh_qz_man_post_label_add,
  jdh_qz_man_post_label_update,
  jdh_qz_man_post_label_remove,
  jdh_qz_man_post_label_delete,
  jdh_qz_man_post_label_page,
} from "../../../../api/man.js"
import { mapState } from 'vuex';
import { uploadFile } from '@/utils/axios'
import { getBusinessId } from "../../../../utils/enum"

export default {
  name: "commonLabel",
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入名称'))
      } else {
        callback()
      }
    }
    return {
      attributeShow: false, // 属性弹窗
      checkList: [
        {
          id: 2,
          name: '写手端不可见'
        },
        {
          id: 3,
          name: 'C端用户不可见'
        }],
      checkedCities: [],
      title: '',
      isRed: false,
      paginationDataProduct: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      tableData: {
        tableList: [],
        tableHeader: [
          {
            label: '标签id',
            prop: 'labelId',
            width: "100px"
          },
          {
            label: '标签名称',
            prop: 'rowLabelList'
          },
          {
            label: '标签描述',
            prop: 'labelDesc'
          },
          {
            label: '是否自动设为展示标签',
            prop: 'isShowDefaultOut',
            width: "120px"
          },
          {
            label: '更新时间',
            prop: 'updateTime',
            width: "120px"
          },
          {
            label: '创建人',
            prop: 'createUser',
            width: "120px"
          },
        ],
        tableType: 4,
      },
      isShowSelect: false,

      // 删除弹框
      deleteDialog: false,
      data: [],
      times: null,
      tableVal: {},
      btnText: ["取消", "确认"],
      // 移动弹框
      moveDialog: false,
      // 合并弹框
      mergeDialog: false,
      mergeMoveBtnText: ["取消", "提交"],
      isShowBtn: [true, true, false],
      labelName: "",
      dialogShow: false,
      dialogShowLabel: false,
      formList: {
        labelName: "",
        nameType: "",
        labelIcon: "",
        labelDesc: "",
        isShowDefault: 0,
        labelStyle: "",
        textStyle: ""
      },
      rules: {
        labelName: [
          { validator: validatePass, trigger: 'blur' }
        ],
        labelDesc: [
          { validator: validatePass, trigger: 'blur' }
        ],
        isShowDefault: [
          { validator: validatePass, trigger: 'blur' }
        ],
        labelStyle: [
          { validator: validatePass, trigger: 'blur' }
        ],
        textStyle: [
          { validator: validatePass, trigger: 'blur' }
        ],
      },
      rules: {
        labelName: [
          { required: true, message: '标签名称不得为空', trigger: 'change' }
        ],
        labelDesc: [
          { required: false, message: '标签描述不得为空', trigger: 'change' }
        ],
        isShowDefault: [
          { required: false, message: '必选是否自动对外展示', trigger: 'change' }
        ],
        labelStyle: [
          { required: true, message: '标签色值不得为空', trigger: 'change' }
        ],
        textStyle: [
          { required: true, message: '文字色值不得为空', trigger: 'change' }
        ],
      },
      invisibleStatus: '',
      breadArray: [
        {
          name: '标签管理',
          path: '',
          query: undefined,
        },
        {
          name: '通用标签',
          path: '/commonLabel/group',
          query: this.$router.query,
        }
      ],
      titlePicUrl: [],
      imgHost: process.env.VUE_APP_imgHost,
      searchParam: ""
    }
  },
  components: {
    baseTable,
    circleTable,
    topBar,
    breadCrumbCas,
    modal,
    pagination,
    ContentLabelCascader,
    uploadImgUniversal
  },
  watch: {
    'formList.labelName'(newValue, oldValue) {
      //
      if (this.$utils.specialCharacters(newValue)) {
        this.$message({
          message: '禁止输入特殊字符',
          type: 'warning'
        });
        this.formList.labelName = this.$utils.removalSpace(newValue)
      }
    },
    formList: {
      handler(newValue, oldValue) {
        this.isRed = false
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    handleSearch() {
      this.jdh_qz_man_post_label_page(this.searchParam)
    },
    handleReset() {
      this.jdh_qz_man_post_label_page()
      this.searchParam = ''
    },
    uploadFileEditor(file, callback) {
      uploadFile(file, (event) => {
        let percent = parseInt((event.loaded / event.total) * 100 + "");
        if (percent > 99) {
          percent = 99;
        }
        file.progress = percent;
        file.status = "pending";
        // this.setStoragePropertyByName(storageProperty, uploadImageList);
      })
        .then(res => {
          const id = res.data[0]["id"];
          if (id === "1") {
            const url = res.data[0]["msg"];
            callback && callback(url);
            file.status = "resolve"; // 是否上传成功，根据是否有url来判断
          } else if (id === "0") {
            this.$message.error("图片上传失败");
          }
        })
        .catch(error => {
          file.status = "reject";
          this.$message.error("图片上传失败");
        });
    },
    httpRequestEditor(request) {
      this.uploadFileEditor(request.file, msg => {
        let url = `//image.healthjd.com/da/` + msg;
        let html = '<img style="max-width:100%" src="' + url + '" />';
        this.editor.insertContent(html);
      });
    },
    // 获取businessId
    getBusinessId(key) {
      return getBusinessId(key)
    },
    changeCheck(val) {
      let numStatus = val.toString();
      let numStr1 = '2,3'
      let numStr2 = '3,2'
      if (numStatus == numStr1 || numStatus == numStr2) {
        this.invisibleStatus = 4
      } else {
        this.invisibleStatus = numStatus
      }
    },
    // 属性弹窗
    btnTextClickHandler(val) {
      if (val === 'one') {
        this.attributeShow = false
        this.checkedCities = []
      } else if (val === 'two') {
        if (this.invisibleStatus == '') {
          this.invisibleStatus = '1'
        }
        getTagAttributes({
          tenantId: this.tableVal.tenantId,
          id: this.tableVal.id,
          invisibleStatus: this.invisibleStatus,
          // updateInvisibleStatusType: this.tableVal.yn
        }).then(res => {
          if (res) {
            this.checkedCities = [];
            this.$message({
              message: '操作成功',
              type: "success",
            });
            this.attributeShow = false;
          }
          this.jdh_qz_man_post_label_page()
        }).catch(err => {
          this.$message.error('操作失败');
        })
        this.attributeShow = false
      }
    },
    paginationChangeProduct(val) {
      this.paginationDataProduct = val
      this.jdh_qz_man_post_label_page()
    },
    handleClick(val) {
      if (val.type === 'edit') {
        console.log("==== edit", val.val)
        this.dialogShowLabel = true
        this.title = "编辑"
        this.formList = {}
        setTimeout(() => {
          this.formList = val.val
          console.log("==== onEdit", val.val)
        }, 500);

      } else if (val.type === 'goAdmin') {
        // 跳转标签下帖子
        this.$router.push({
          path: `/postMarkLabel`,
          query: {
            labelId: val.val.labelId,
            labelName: val.val.labelName
          }
        })
      } else if (val.type === 'delete') {
        this.deleteDialog = true
        this.formList = val.val
      } else if (val.type === 'attribute') {
        this.attributeShow = true
        this.tableVal = val.val
        // 属性值回显
        if (val.val.invisibleStatus !== 1) {
          if (val.val.invisibleStatus == 4) {
            this.checkedCities = [2, 3]
          } else {
            this.checkedCities = [val.val.invisibleStatus]
          }
        }
        this.invisibleStatus = val.val.invisibleStatus
      } else if (val.type === 'moveLabel') {
        this.moveDialog = true
        this.tableVal = val.val
      } else if (val.type === 'mergeLabel') {
        this.mergeDialog = true
        this.tableVal = val.val
      }
    },
    // 删除弹框
    deleteClickHandler(val) {
      if (val === 'one') {
        this.deleteDialog = false
      } else if (val === 'two') {
        this.jdh_qz_man_post_label_delete(this.formList)
        // this.deleteDialog=false
      }
    },
    // 删除
    jdh_qz_man_post_label_delete(val) {
      console.log("==== delete", val)
      jdh_qz_man_post_label_delete({
        tenantId: this.$commonJs.getTenantId(),
        businessId: this.getBusinessId(this.$commonJs.getTenantId()),
        labelId: val.labelId
      })
        .then(res => {
          if (res) {
            this.$message({
              message: '删除成功',
              type: 'success'
            })
          }
          this.deleteDialog = false
          this.paginationDataProduct.currentPage = 1;
          this.jdh_qz_man_post_label_page()
        })
        .catch(res => {
          // if(res.data===-1) {
          this.$message.error(
            res.msg
          )
          // }
        })
    },
    // 新增弹框
    handleCancelActivateLabel() {
      this.dialogShowLabel = false
      this.jdh_qz_man_post_label_page()
    },
    async handleActivateLabel(val) {
      await this.$refs['formList'].validate((valid) => {
        if (valid) {
          console.log('submit!')
          val == '新增' ?
            jdh_qz_man_post_label_add({
              tenantId: this.$commonJs.getTenantId(),
              businessId: this.getBusinessId(this.$commonJs.getTenantId()),
              labelIcon: this.formList.labelIcon,
              labelName: this.formList.labelName,
              labelDesc: this.formList.labelDesc,
              isShowDefault: this.formList.isShowDefault || 0,
              labelStyle: this.formList.labelStyle,
              textStyle: this.formList.textStyle,
              labelSource: 0,
            }).then((res) => {
              console.log("==== 新增", res)
              if (res.data == 0) {
                this.$message.success('新增标签成功')
                this.dialogShowLabel = false,
                  this.jdh_qz_man_post_label_page()
              } else if (res == 1) {
                this.$message.error('标签名称重复')
              } else if (res == -1) {
                this.$message.error('新增标签失败')
              } else {
                this.$message.error('新增标签失败')
              }

            }) :
            jdh_qz_man_post_label_update({
              tenantId: this.$commonJs.getTenantId(),
              businessId: this.getBusinessId(this.$commonJs.getTenantId()),
              labelIcon: this.formList.labelIcon,
              labelName: this.formList.labelName,
              labelDesc: this.formList.labelDesc,
              isShowDefault: this.formList.isShowDefault || 0,
              labelStyle: this.formList.labelStyle,
              textStyle: this.formList.textStyle,
              labelSource: this.formList.labelSource,
              labelId: this.formList.labelId
            }).then((res) => {
              console.log("=== edit", res)
              if (res.data == 0) {
                this.$message.success('修改标签成功')
                this.dialogShowLabel = false,
                  this.jdh_qz_man_post_label_page()
              } else if (res.data == 1) {
                this.$message.error('标签名称重复')
              } else if (res.data == -1) {
                this.$message.error('修改标签失败')
              } else {
                this.$message.error('修改标签失败')
              }

            })
        } else {
          console.log('error submit!')
          this.$message.error('请填写完整')
        }
      })
    },
    // 合并弹框
    mergeClickHandler(val) {
      if (val === 'one') {
        this.mergeDialog = false
      } else if (val === 'two') {
        this.$refs.moveSelectedRef.handleClick();
        // this.deleteDialog=false
      }
    },
    // 移动弹框
    moveClickHandler(val) {
      if (val === 'one') {
        this.moveDialog = false
      } else if (val === 'two') {
        // this.jdh_qz_man_post_label_delete(this.tableVal)
        console.log(this.$refs, 9999);
        this.$refs.moveSelectedRef.handleClick();
        // this.deleteDialog=false
      }
    },
    formatDate(date) {
      if (!date) return '';
      const d = new Date(date);
      const pad = (n) => n.toString().padStart(2, '0');
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },
    // 分页
    jdh_qz_man_post_label_page(searchParam) {
      let vm = this
      console.log("==== jdh_qz_man_post_label_page", this.paginationDataProduct.currentPage)
      jdh_qz_man_post_label_page({
        tenantId: this.$commonJs.getTenantId(),
        businessId: this.getBusinessId(this.$commonJs.getTenantId()),
        pageNo: this.paginationDataProduct.currentPage,
        pageSize: this.paginationDataProduct.pageSize,
        labelName: this.searchParam ? this.searchParam : ""
      })
        .then(res => {
          console.log("🚀 ~ jdh_qz_man_post_label_page ~ res:", res)
          this.tableData.tableList.splice(0, this.tableData.tableList.length)
          res.data.map(item => {
            item.updateTime = this.formatDate(item.updateTime)
            item.isShowDefaultOut = item.isShowDefault == 1 ? '是' : '否'
            item.rowLabelList = {
              labelName: item.labelName,
              labelStyle: item.labelStyle,
              textStyle: item.textStyle,
              labelIcon: item?.labelIcon
            }
            console.log("==== item", item)
            this.tableData.tableList.push(item)
          })
          vm.paginationDataProduct.total = res.totalCount
          vm.paginationDataProduct.currentPage = res.pageNo
          vm.paginationDataProduct.pageSize = res.pageSize
        })
    },
    clickAddButton() {
      this.title = '新增'
      this.formList = {
        labelName: "",
        nameType: "",
        labelIcon: "",
        labelDesc: "",
        isShowDefault: false,
        isShowDefaultOut: false,
        labelStyle: "",
        textStyle: ""
      }
      this.dialogShowLabel = true
    },
    handleDialog(val) {
      this.dialogShow = val
    },
    handleDialogLabel(val) {
      // dialogShowLabel
      this.dialogShowLabel = val
    },
    handleDialogSubmit() {
      this.handleDialog(false)
    },
    handleDialogSubmitLabel() {
      this.handleDialogLabel(false)
    },
    // 新增
    saveOrUpdateLabelGroup(name) {
      saveOrUpdateLabelGroup({
        id: this.tableVal.id == undefined ? '' : this.tableVal.id,
        labelType: 1,
        name: name,
        tenantId: this.$commonJs.getTenantId(),
      }).then(res => {
        this.isRed = false
        this.dialogShowLabel = false
        this.jdh_qz_man_post_label_page()
      }).catch(error => {
        this.$message.error(error.msg)
      })
    },
    // 上传
    changeTitlePic(data) {
      console.log('==== I AM INIT PIC', data)
      // data-封面组件的返回值
      this.titlePicUrl = data;
      if (this.titlePicUrl && this.titlePicUrl.length > 0) {
        let url = this.titlePicUrl[0].url;
        // url 要截去的那部分 这个要从环境变量中取
        const startIndex = url.indexOf('jfs');
        if (startIndex !== -1) {
          const result = url.substring(startIndex);
          this.formList.labelIcon = result
          console.log("======= uploaded", this.formList.labelIcon)
        } else {
          console.log('String "jfs" not found in the given string.');
        }
        console.log("=======DATA", data)
      } else {
        this.formList.labelIcon = "";
      }
    },
  },
  created() {
    this.jdh_qz_man_post_label_page()
  },
};
</script>

<style lang="scss" scoped>
.dialogVal {
  color: #5f5f6b;
  font-size: 16px;
  padding: 30px 0px;
  padding-bottom: 0px;
  text-align: center;
}

.common-audit-tabel {
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  background: white;
  margin-top: 14px;
}

.input-container {
  display: flex;
  justify-content: center;
  padding-top: 20px;

  .input-suffix {
    .el-input {
      width: 276px;
    }
  }
}

.base-dialog {
  width: 400px;
  padding: 30px 26px 0;
  position: relative;
  font-size: 14px;
  color: #2c3443;

  &-input {
    width: 276px;
  }

  &-textarea {
    width: 276px;
    padding-top: 10px;
  }

  .el-form-item__label {
    width: 68px;
    font-weight: bolder;
  }

  .el-input__inner {
    height: 32px;
  }

  // .el-form-item__error {
  //   left: 68px;
  // }
  &__body {
    padding: 30px 26px;
  }

  &__header {
    background-color: #f7f8fb;
    height: 46px;
    display: flex;
    align-items: center;

    .el-dialog__title {
      font-size: 16px;
      color: #333840;
      font-weight: bolder;
    }
  }
}

.base-dialog-input-border {
  position: relative;

  &>input {
    border: 1px solid #F56C6C;
  }
}

.rules {
  position: absolute;
  font-size: .5em;
  color: #F56C6C;
  bottom: -28px;
  left: 0px;
}

.drawer-footer {
  position: absolute;
  bottom: 0;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 10px;
  border-top: 1px solid #ebeef5;
  background-color: #fff;
  /* 确保背景色 */
}

.button-group {
  display: flex;
  gap: 10px;
}

.input-group {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  width: 100%;
  justify-content: space-between;
}
</style>
